"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TimeConversionController_1 = __importDefault(require("./controllers/TimeConversionController"));
var TimeConversionService_1 = __importDefault(require("./services/TimeConversionService"));
var TimeConverter = /** @class */ (function () {
    function TimeConverter() {
    }
    TimeConverter.prototype.convertUnixToArdorTimestamp = function (timestampInMsec, isTestnetTimestamp) {
        if (isTestnetTimestamp === void 0) { isTestnetTimestamp = false; }
        var controller = new TimeConversionController_1.default(new TimeConversionService_1.default());
        return controller.unixToArdor(timestampInMsec, isTestnetTimestamp);
    };
    TimeConverter.prototype.convertArdorToUnixTimestamp = function (timestamp, isTestnetTimestamp) {
        if (isTestnetTimestamp === void 0) { isTestnetTimestamp = false; }
        var controller = new TimeConversionController_1.default(new TimeConversionService_1.default());
        return controller.ardorToUnix(timestamp, isTestnetTimestamp);
    };
    return TimeConverter;
}());
exports.default = TimeConverter;
